<template>
  <RevDrawer
    :close-button-label="i18n(translations.close)"
    :has-padding="false"
    :name="MODAL_NAMES.OBSOLETE_COMPUTER"
    :title="i18n(translations.title)"
  >
    <template #body>
      <ObsoleteComputerModalBody />
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import { MODAL_NAMES } from '~/scopes/product/constants'

import ObsoleteComputerModalBody from '../ObsoleteComputerModalBody/ObsoleteComputerModalBody.vue'

import translations from './ObsoleteComputerModal.translations'

const i18n = useI18n()
</script>
